import { createContext } from "react";

export type TourTargetsContextValue = {
  register: (name: string, element: HTMLElement) => void;
  unregister: (name: string, element: HTMLElement) => void;
  get: (name: string) => HTMLElement | null;
};

export const TourTargetsContext = createContext<TourTargetsContextValue | null>(null);
